import React from 'react'
import LOGO from '../assets/svgs/varianti_logo.svg';
import { auth } from "../../firebase";

export default function Fallback() {
    return (
        <div style={{
            padding: 20,
            backgroundColor: '#fecccb',
            width: '100vw',
            height: '100vh'
        }}>
            <img src={LOGO} alt="" style={{ width: 100, margin: 'auto' }} />
            <h1 style={{ color: '#FFF', }}>დაფიქსირდა შეცდომა!</h1>
            <button onClick={() => {
                auth.signOut();
            }} className={"btn btn-dark"}>გამოსვლა</button>
        </div>
    )
}
